// For call sites whose non-nullness is locally provable but inexpressible in
// the type system — the alternative to a banned bare `!`. Exists as a shared
// helper (rather than inline throws) because an inline `if (x == null) throw`
// adds condition/block/StringLiteral mutants killable only by fabricating
// impossible inputs, while a bare assertDefined(x) statement adds exactly one
// StrykerJS mutant — the CallExpression (statement-removal) one — which the
// call site suppresses with `// Stryker disable next-line CallExpression:
// <why it never fires>` on its own line above the call. Call sites pass no
// message — message strings would reintroduce StringLiteral mutants.
export function assertDefined<T>(value: T): asserts value is NonNullable<T> {
  if (value == null) throw new Error('assertDefined: value is nullish');
}
